// extracted by mini-css-extract-plugin
export default {"table":"x5Y65ubGDQoVsCbUuZpO"};